<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('editBuilding.properties') }}</router-link> /
            <span class="color-main">{{ $t('editBuilding.editBuilding') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('editBuilding.subtitle') }}</p>
        </div>
      </div>
      <div class="white-box">
        <div class="main-title-box">{{ $t('editBuilding.editBuilding') }}</div>
        <div class="main-body-box">
          <div class="col-md-8 col-12">
            <v-form @submit.prevent="addBuilding" v-model="valid" ref="form">
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.nameAr') }}</h6>
                <v-text-field
                  type="text"
                  v-model="nameAr"
                  name="name[ar]"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.nameArPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.nameEn') }}</h6>
                <v-text-field
                  type="text"
                  v-model="nameEn"
                  name="name[en]"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.nameEnPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mb-4">
                <h6 class="mb-2 font14">{{ $t('editBuilding.buildingType') }}</h6>
                <Dropdown
                  v-model="selectedBuilding"
                  :options="buildingType"
                  filter
                  optionLabel="name"
                  :placeholder="$t('editBuilding.buildingTypePlaceholder')"
                  :emptyFilterMessage="$t('noData.noDataToShow')"
                :emptyMessage="$t('noData.noDataToShow')"
                  class="main-select"
                />
              </div>
              <div class="main-input-cont mt-1" @click="showMap = true">
                <h6 class="mb-2 font14">{{ $t('editBuilding.buildingAddress') }}</h6>
                <v-text-field
                  type="text"
                  v-model="address"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.addressPlaceholder')"
                ></v-text-field>
                <div class="absLeft pointer-none">
                  <i class="fa-solid fa-map-pin"></i>
                </div>
              </div>
              <div class="main-input-cont mt-1 mb-4">
                <div class="flex-big-gap">
                  <div class="all-container-type">
                    <h6 class="mb-3">{{ $t('editBuilding.buildingUse') }}</h6>
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        :checked="checkUseModal === 'living'"
                        name="use"
                        value="living"
                        v-model="checkUseModal"
                        @change="checkUse"
                        id="company"
                        class="mainRadio"
                      />
                      <label for="company" class="font14">{{ $t('editBuilding.residential') }}</label>
                    </div>
                  </div>
                  <div class="all-container-type">
                    <h6 class="styleOnly mb-3">styleOnly</h6>
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        id="user"
                        :checked="checkUseModal === 'commercial'"
                        @change="checkUse"
                        v-model="checkUseModal"
                        value="commercial"
                        name="use"
                        class="mainRadio"
                      />
                      <label for="user" class="font14">{{ $t('editBuilding.commercial') }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.buildingCode') }}</h6>
                <v-text-field
                  type="number"
                  v-model="code"
                  name="ref_code"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.buildingCodePlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.buildingAge') }}</h6>
                <v-text-field
                  type="text"
                  v-model="age"
                  name="age"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.buildingAgePlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.buildingArea') }}</h6>
                <v-text-field
                  type="text"
                  v-model="area"
                  name="area"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.buildingAreaPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.ownerRatio') }}</h6>
                <v-text-field
                  v-model="ratio"
                  type="text"
                  name="ratio"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.ownerRatioPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.apartmentsCount') }}</h6>
                <v-text-field
                  v-model="number"
                  type="number"
                  name="units_count"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.apartmentsCountPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1" v-if="showCommercial || checkUseModal == 'commercial'">
                <h6 class="mb-2 font14">{{ $t('editBuilding.shopsCount') }}</h6>
                <v-text-field
                  type="number"
                  v-model="shop_count"
                  name="shops_count"
                  :rules="defaultRoles"
                  :placeholder="$t('editBuilding.shopsCountPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.descriptionAr') }}</h6>
                <v-textarea
                  :rules="defaultRoles"
                  v-model="descAr"
                  name="description[ar]"
                  rows="7"
                  :placeholder="$t('editBuilding.descriptionArPlaceholder')"
                ></v-textarea>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('editBuilding.descriptionEn') }}</h6>
                <v-textarea
                  :rules="defaultRoles"
                  v-model="descEn"
                  name="description[en]"
                  rows="7"
                  :placeholder="$t('editBuilding.descriptionEnPlaceholder')"
                ></v-textarea>
              </div>
              <div class="main-input-cont">
                <div class="flex-big-gap no-align yes-wrap">
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('editBuilding.managementContract') }}</div>
                    <uploadFileSingle
                      name="contract"
                      id="uploadbuildingpaper"
                      :uploadedFile="uploadedFile"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('editBuilding.propertyDeed') }}</div>
                    <uploadFileSingle
                      name="instrument"
                      id="uploadbuildingpaper2"
                      :uploadedFile="uploadedFile2"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('editBuilding.constructionCertificate') }}</div>
                    <uploadFileSingle
                      name="construction_completion_certificate"
                      id="uploadbuildingpaper3"
                      :uploadedFile="uploadedFile3"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('editBuilding.civilDefenseCertificate') }}</div>
                    <uploadFileSingle
                      name="civil_defense_certificate"
                      id="uploadbuildingpaper4"
                      :uploadedFile="uploadedFile4"
                    />
                  </div>
                </div>
              </div>

              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl mt-4 mb-3"
              >
                <div v-if="!disabled">{{ $t('editBuilding.saveChanges') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('editBuilding.saving') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </main>

  <!-- Map modal  -->
  <Dialog v-model:visible="showMap" modal :style="{ width: '50vw' }">
    <h6 class="text-center py-3">{{ $t('editBuilding.addressOnMap') }}</h6>
    <div class="modal-body-main">
      <div id="map" style="min-height: 300px">
        <GoogleMap
          api-key="AIzaSyCGt8Jhn_NTdYJVqlyNfH5YQUXJyngCVok"
          :language="locale"
          :autocomplete="true"
          @change-address="getAddess"
          :location="center"
        />
      </div>
    </div>
  </Dialog>

  <!-- success modal  -->
  <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3 mt-2">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font18 mb-4">
        {{ $t('editBuilding.buildingEditedSuccess') }}
      </h6>
      <div class="flex-group-me mb-2">
        <router-link :to="'/addTenant/' + buildingId" class="main-btn lg up">
          {{ $t('editBuilding.addTenants') }}
        </router-link>
        <router-link :to="'/buildingDetails/' + buildingId" class="main-btn lg up trans">
          {{ $t('editBuilding.buildingDetails') }}
        </router-link>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import uploadFileSingle from "../components/dashboard/uploadFileSingle.vue";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import GoogleMap from "vue-google-maps-ui";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
const toast = useToast();
const route = useRoute();
import { ref, onMounted } from "vue";
const { t } = useI18n();

// locale
import i18n from "@/i18n";
const locale = i18n.global.locale;

// reactive state
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('editBuilding.fieldRequired');
  },
]);
const center = ref({ lat: null, lng: null });
const successImg = ref(require("../assets/imgs/check.png"));
const showMap = ref(false);
const showSuccess = ref(false);
const showCommercial = ref(false);
const valid = ref(false);
const lat = ref(null);
const lng = ref(null);
const disabled = ref(false);
const form = ref(null);
const address = ref("");
const checkUseModal = ref("");
const selectedBuilding = ref(null);
const buildingType = ref([]);


// upload file refs
const uploadedFile = ref(null)
const uploadedFile2 = ref(null)
const uploadedFile3 = ref(null)
const uploadedFile4 = ref(null)

// form v-models
const shop_count = ref("");
const nameAr = ref("");
const nameEn = ref("");
const descAr = ref("");
const descEn = ref("");
const code = ref("");
const age = ref("");
const area = ref("");
const ratio = ref("");
const number = ref("");

// buildingId
const buildingId = ref(null);

// functions
function getBuilding() {
  axios
    .get(`/manager/building-details/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      console.log(response.data.data)
      nameAr.value = response.data.data.name_ar;
      nameEn.value = response.data.data.name_en;
      descEn.value = response.data.data.description_en;
      descAr.value = response.data.data.description_ar;
      selectedBuilding.value = response.data.data.type;
      address.value = response.data.data.map_desc;
      lat.value = response.data.data.lat;
      lng.value = response.data.data.lng;
      center.value.lat = Number(response.data.data.lat);
      center.value.lng = Number(response.data.data.lng);
      code.value = response.data.data.ref_code;
      age.value = response.data.data.age;
      area.value = response.data.data.area;
      ratio.value = response.data.data.ratio;
      number.value = response.data.data.units_count;
      shop_count.value = response.data.data.shops_count;
      checkUseModal.value = response.data.data.use;
      uploadedFile.value = response.data.data.contract;
      uploadedFile2.value = response.data.data.instrument;
      uploadedFile3.value = response.data.data.construction_completion_certificate;
      uploadedFile4.value = response.data.data.civil_defense_certificate;

    });
}
function addBuildingSend() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);

  fd.append("lat", lat.value);
  if (selectedBuilding.value) {
    fd.append("building_type_id", selectedBuilding.value.id);
  }
  fd.append("lng", lng.value);
  fd.append("map_desc", address.value);

  axios
    .post(`/manager/update-building/${route.params.id}?_method=put`, fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        buildingId.value = response.data?.data?.id;
        showSuccess.value = true;
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function checkUse() {
  if (checkUseModal.value == "commercial") {
    showCommercial.value = true;
  } else {
    showCommercial.value = false;
  }
}
function getBuildingsTypes() {
  axios.get("/building-types").then((response) => {
    buildingType.value = response.data.data;
  });
}
function getAddess(e) {
  address.value = e.address;
  lat.value = e.info.geometry.location.lat();
  lng.value = e.info.geometry.location.lng();
}

// addBuilding
function addBuilding() {
  if (valid.value) {
    addBuildingSend();
  } else {
    scrollToDanger();
  }
}
// scroll to danger input
function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}

// lifecycle hooks
onMounted(() => {
  getBuildingsTypes();
  getBuilding();
  checkUse();
});
</script>
